<template>
    <div class="content">
      <base-header class="pb-6" :class="AppStyle.GRADIENT_STYLE">
        <b-row align-v="center" class="py-4">
          <b-col cols="7" lg="6">
            <h6 :class="AppStyle.BREADCRUMB_H_STYLE" class="h2 d-inline-block mb-0">Contacts</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <h3 class="mb-0">Contacts</h3>
              <p class="text-sm mb-0">
                Find your contacts here
              </p>
            </template>
            <div>
              <b-col
                cols="12"
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="per Page"
                  @change="handlePageSizeChange"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
  
                <div>
                  <base-input
                    v-model="searchQuery"
                    prepend-icon="fas fa-search"
                    placeholder="search..."
                    @keyup="searchContacts"
                  >
                  </base-input>
                </div>
              </b-col>
  
              <div class="loader" v-if="loading"></div>
  
              <el-table
                class="table-responsive align-items-center table-flush table-striped"
                header-row-class-name="thead-light"
                :data="contacts"
                v-if="contacts.length > 0"
              >

                <el-table-column label="FB" min-width="60px">
                  <div slot-scope="{ $index, row }" class="d-flex" v-html="feedback_smiley(contacts[$index])">
                  </div>
                </el-table-column>

                <el-table-column
                  label="Instagram"
                  min-width="160px"
                  prop="instagram_profile"
                  sortable
                >
                </el-table-column>

                <el-table-column
                  label="Firstname"
                  min-width="150px"
                  prop="firstname"
                  sortable
                >
                </el-table-column>
                <el-table-column
                  label="Lastname"
                  min-width="150px"
                  prop="lastname"
                  sortable
                >
                </el-table-column>
                <el-table-column
                  label="email"
                  min-width="150px"
                  prop="email"
                  sortable
                >
                </el-table-column>
  
                <el-table-column
                  label="editor"
                  min-width="200px"
                  prop="editor"
                  sortable
                >
                </el-table-column>

                <el-table-column label="created" min-width="120px" sortable>
                  <div slot-scope="{ $index, row }" class="d-flex">
                    {{ formatDate(contacts[$index].created_at) }}
                  </div>
                </el-table-column>
  
                <el-table-column min-width="180px" align="right" label="Optionen">
                  <div slot-scope="{ $index, row }" class="d-flex">
                    <a
                      href="#"
                      :class="AppStyle.BUTTON_STYLE"
                      class="btn btn-sm"
                      @click="showContact(contacts[$index].id)"
                      ><i class="fas fa-desktop"></i
                    ></a>
                  </div>
                </el-table-column>
              </el-table>
            </div>
  
            <b-card-footer class="py-4 d-flex justify-content-end">

              <base-pagination
                class="pagination-no-border"
                :current="page"
                :per-page="pageSize"
                :total="count"
                @change="handlePageChange($event)"
              >
              </base-pagination>
            </b-card-footer>
          </card>
        </div>
      </b-container>
    </div>
  </template>
  <script>
  import {
    Table,
    TableColumn,
    Select,
    Option,
    DropdownMenu,
    DropdownItem,
    Dropdown,
  } from "element-ui";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
  import { BasePagination } from "@/components";
  import LightTable from "../Tables/RegularTables/LightTable";
  import { TablePlugin } from "bootstrap-vue";
  import moment from "moment";
  
  import AppStyle from '@/plugins/appStyle';
  import formatDateMixin from '@/plugins/formatDateMixin';
  import swal from '@/services/swal';
  
  export default {
    mixins: [AppStyle.Mixin, formatDateMixin],
    components: {
      BasePagination,
      RouteBreadCrumb,
      LightTable,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        loading: false,
        contacts: [],
        count: 0,
        page: 1,
        pageSize: 10,
        pageCount: 0,
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0,
        },
        searchQuery: "",
        searchedData: [],
      };
    },
    methods: {
      getRequestParams(searchTitle, page, pageSize) {
        let params = {};
  
        if (searchTitle) {
          params["search"] = searchTitle;
        }
  
        if (page) {
          params["page"] = page;
        }
  
        if (pageSize) {
          params["per_page"] = pageSize;
        }
  
        return params;
      },
      retrieveContacts() {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        this.loading = true;
        this.$api
          .getContacts(params)
          .then((response) => {
            const { contacts, count, page, page_count } = response.data;
            this.contacts = response.data.contacts;
            this.page = response.data.page;
            this.pageCount = response.data.page_count;
            this.count = response.data.count;
            this.pagination.total = response.data.count;
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      searchContacts() {
        const params = this.getRequestParams(
          this.searchQuery,
          this.page,
          this.pageSize
        );
        this.loading = true;
        this.$api
          .searchContacts(params)
          .then((response) => {
            const { contacts, page, page_count, count } = response.data;
            this.contacts = contacts;
            (this.page = page), (this.pageCount = page_count);
            this.count = count;
  
            //console.log(response.data);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      handlePageChange(value) {
        this.page = value;
        this.retrieveContacts();
      },
  
      handlePageSizeChange(value) {
        this.pageSize = value;
        this.page = 1;
        this.retrieveContacts();
      },
      showContact(contactId) {
        //this.$router.push({ path: `/contacts/${this.contact.token}` })
        //this.$router.push({ path: `/contacts/${contactId}` })
        //this.$router.push({ path: `/contacts/${contactId}`, query: { tab: 'Dokumente' } })
        this.$router.push({
          name: "Schaden anzeigen",
          params: { token: `${contactId}`, tab: "Dokumente" },
        });
      },

      feedback_smiley(record){
        let html = "";
        if(record.blacklisted == 1){
            html = "<i class=\"fa fa-solid fa-thumbs-down\"></i>";
        }
        if(record.feedback_type == "0"){
            html += "<i class=\"fas fa-smile text-success\"></i>";
        }
        if(record.feedback_type == "1"){
            html += "<i class=\"fas fa-flushed text-warning\"></i>";
        }
        if(record.feedback_type == "2"){
            html += "<i class=\"fas fa-angry text-danger\"></i>";
        }
        if(record.feedback_type == "3"){
            html += "<i class=\"fas fa-ban\"></i>";
        }
        return html;
      }
    },
    computed: {
      searchRegExp() {
        return new RegExp(`(.*)${this.search}(.*)`);
      },
      rows() {
        return this.contacts.length;
      },
    },
    created() {
      this.retrieveContacts();
    },
  };
  </script>
  <style scoped>
  #axiosForm {
    /* Components Root Element ID */
    position: relative;
  }
  .loader {
    /* Loader Div Class */
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url(/img/custom/ajax-loader.gif);
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
  }
  </style>